import React from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type LogoutDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const LogoutDialog: React.FC<LogoutDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="rounded-xl px-4 py-4 sm:max-w-[500px] sm:px-6">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold flex items-center">
            {t("logoutDialog.title")}
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm">{t("logoutDialog.message")}</p>

        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            className="cursor-pointer border-[#146AFF] text-[#146AFF] hover:text-[#146AFF] hover:bg-white py-2 px-4"
          >
            {t("logoutDialog.cancel")}
          </Button>

          <Button
            variant="destructive"
            onClick={onConfirm}
            className="cursor-pointer bg-[#E53935] hover:bg-[#E53935] text-white  py-2 px-4"
          >
            {t("logoutDialog.confirm")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutDialog;
